import request from '@/api/request'
// ************************************************************************
// export function queryTimeList (data) {
//   // 获取开课的日期时间list
//   return request({ url: '/soutools/course/query/timeScope', method: 'post', data })
// }
export function queryCourseData (data) {
  // 获取项目二级数据
  return request({ url: '/soutools/v2/course/query/common', method: 'post', data })
}

export function ipqQueryCourseData (data) {
  // 获取ipq项目二级数据
  return request({ url: '/soutools/v2/course/query/ipq', method: 'post', data })
}

// 获取学科项目
export function queryTerritoryData (data) {
  return request({ url: '/territory/query/summary', method: 'post', data })
}

export function queryTimeList (data) {
  // 获取开课的日期时间list
  return request({ url: '/soutools/v2/course/query/timeScope', method: 'post', data })
}

// 封面列表
export function queryImageList1 (data) {
  // 获取开课的日期时间list
  return request({ url: '/imageClient/query/summary/image', method: 'post', data })
}

// 竞赛列表
export function queryCompetition (data) {
  // 获取开课的日期时间list
  return request({ url: '/soutools/v2/course/query/competition', method: 'post', data })
}
// 分享参数换ID
export function queryArgsToId (data) {
  return request({ url: '/course/argsToId', method: 'post', data })
}
// ID换参数
export function queryIdToArgs (data) {
  return request({ url: '/course/idToArgs', method: 'post', data })
}

// aihub
export function queryAiHub (data) {
  return request({ url: '/soutools/v2/course/query/aiHub', method: 'post', data })
}
// 获取项目列表
export function getCombinationCourseList (data) {
  return request({ url: '/course/query/combinationCourseList', method: 'post', data })
}
// 获取项目详情
export function getCombinationPoster (data) {
  return request({ url: '/course/query/combinationPoster', method: 'post', data })
}
export function queryTimeList2 (data) {
  // 获取开课的日期时间list
  return request({ url: '/soutools/v2/course/query/timeScope', method: 'post', data })
}
export function queryCourseDataOC (data) {
  // 20220929 接口的level = 9999 代表全部，但由于之前用的4，而且有的链接已经发出去了，故在这里搞了个修饰器，在queryCourseData方法里做的改动
  return request({ url: '/soutools/course/query/course', method: 'post', data })
}
